import React from 'react';
import { bindActionCreators } from 'redux';
import { Catalog, ScrollToTop } from '@netexknowledge/smart-components';
import { I18n } from 'react-redux-i18n-lite';
import { getTokenFromStorage } from '../../shared';
import { CMI5, LIBRARY, PARAMS } from '../../const';
import { API_CMS_SEARCH, API_CMS_CUSTOMERS_RESOURCES_PREVIEW } from '../../services/api/apiConst';
import axios from 'axios';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link } from 'react-router';
import CustomIcon from '../common/CustomIcon';
import * as drawerActions from '../../actions/drawerActions';
import { trackCatalogAnalyticsEvent } from '../../services/api/analyticsApi';
import { getUnitFileActivityIds } from '../../services/domain/unitFileActivityIds';

class ResourcesPreviewPanelContent extends React.Component {
  constructor(props) {
    super(props);
    this.closePanel = this.closePanel.bind(this);
  }
  static propTypes = {
    locale: PropTypes.string.isRequired,
    customerId: PropTypes.number.isRequired,
    schoolId: PropTypes.number.isRequired,
    selectorNames: PropTypes.array.isRequired,
    classroomId: PropTypes.string.isRequired,
    unit: PropTypes.object.isRequired,
    drawerActions: PropTypes.object.isRequired,
    skinUrl: PropTypes.string.isRequired,
    catalogFiltersExpandedByDefault: PropTypes.bool,
  };
  getFileTypesFilterFields = () => {
    const { locale } = this.props;
    const fields = [];

    Object.keys(LIBRARY.FILE_TYPES).forEach(key => {
        const fileType = LIBRARY.FILE_TYPES[key];
        fields.push({
        label: I18n._getTranslations()[locale]['fileTypes'][fileType],
        value: fileType
        });
    });

    return fields;
  };

  closePanel() {
    const { drawerActions } = this.props;
    drawerActions.closeDrawerAndRemoveContent();
  }

  renderHeader() {
    return (
      <div className="header">
        <Link className="close" onClick={this.closePanel.bind(this)}>
          <CustomIcon name="close-button" size={24} />
        </Link>
        <span>{I18n.t('rightPanel.resources.resourcesPreview')}</span>
      </div>
    );
  }
  render() {
    const { customerId, schoolId, selectorNames, classroomId, locale, unit, skinUrl, catalogFiltersExpandedByDefault } = this.props;
    return (
      <div className="right-panel-new resources-preview-panel" ref="resourcesPreviewPanel" id="resources-preview-panel" >
        <div className="resources-preview-right-panel-content">
          <ScrollToTop contentQuerySelector=".drawer-container" style={{
            marginLeft: '0',
            right: '80px',
          }}></ScrollToTop>
          {this.renderHeader()}
          <div className="resources-preview-right-panel-content-items">
            <Catalog
              classroomId={classroomId}
              onAnalyticsEvent={trackCatalogAnalyticsEvent(classroomId)}
              authToken={getTokenFromStorage()}
              activityTypeBookId= {CMI5.ACTIVITY_TYPE.COURSE}
              activityTypeUnitId= {CMI5.ACTIVITY_TYPE.UNIT}
              activityTypeLessonId= {CMI5.ACTIVITY_TYPE.LESSON}
              activityTypeDefaultId= {CMI5.ACTIVITY_TYPE.DEFAULT}
              fileTypeId= {CMI5.ACTIVITY_TYPE.RESOURCE}
              searchUrl={API_CMS_SEARCH.replace(PARAMS.CUSTOMER, customerId)
                .replace(PARAMS.SCHOOL, schoolId)
                .replace(PARAMS.TYPE, ':type')}
              previewUrl= ""
              bookDetailsUrl= ""
              competenciesUrls= {[]}
              fixedResourceType = "file"
              filePreviewUrl= {API_CMS_CUSTOMERS_RESOURCES_PREVIEW.replace(PARAMS.CUSTOMER, customerId)}
              skinUrl= {skinUrl}
              selectorNames= {selectorNames}
              translationsObject={I18n._getTranslations()[locale]?.catalog}
              axios= {axios}
              fileTypesFilterFields={this.getFileTypesFilterFields()}
              disableImports= {{
                book: true,
                unit: true,
                lesson: true,
                activity: true,
                file: true,
              }}
              defaultUnitId={getUnitFileActivityIds(unit).join(',')}
              defaultShowFilters={catalogFiltersExpandedByDefault}
          />
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    customerId: state.account.configuration.customerId,
    schoolId: state.school.school.id,
    selectorNames: state.account.configuration.competencyConfiguration,
    classroomId: state.classrooms.selectedClassroom.classroom.id,
    locale: state.account.user.language,
    unit: state.book.selectedResource,
    i18n: state.i18n,
    skinUrl: state.theme.skinUrl,
    catalogFiltersExpandedByDefault: state.account.configuration.catalogFiltersExpandedByDefault,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    drawerActions: bindActionCreators(drawerActions, dispatch),
    dispatch
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ResourcesPreviewPanelContent);